import { ListCarRentals } from '~/features/africa/Organization/CarRentals/ListCarRentals'
import { Container } from '~/shared/ui/Layout'

export function ListCarRentalPageAfrica() {
  return (
    <Container>
      <ListCarRentals />
    </Container>
  )
}
